<template>
    <div>
        <div style="margin-top: 200px" v-show="loading">
            <ring-loader></ring-loader>
            <h1>Cargando...</h1>
        </div>

        <b-container style="min-height: 85vh;" v-show="!loading">
            <b-row>
                <b-col md="3" offset="8">
                    <b-card id="timer-card" class="mt-5 shadow font-weight-bold" v-show="question">
                        <p class="mb-0">Tiempo restante</p>
                        <span>{{timer}}</span>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="10" offset="1">
                    <b-card class="mt-5 mb-3 shadow" :title="title">
                        <div v-if="!loading && question">
                            <hr v-show="question.image_url">
                            <img :src="question.image_url" width="200px" v-show="question.image_url">
                            <hr v-show="question.image_url">
                            <label v-for="answer in question.answers" :key="answer.id"
                                   style="display: block">
                                <input type="radio" name="answer" v-model="selected" :value="answer.id">
                                {{answer.answer}}
                            </label>
                        </div>

                        <div v-if="!loading && !question">
                            <h2>Ya no hay más preguntas disponibles por ahora &#x1F61F;</h2>
                            <hr>
                            <h5>Te invitamos a participar creando más preguntas!</h5>
                            <p>Puedes hacerlo desde la app oficial en la opción "Foro, encuestas"</p>
                            <p>O también iniciando sesión en https://legionanime.xyz en el módulo de Trivia.</p>
                            <router-link to="/trivia" class="font-weight-bold mt-5" style="text-decoration: underline;"> &lt;&lt; Regresar al listado de animes</router-link>
                        </div>
                    </b-card>

                    <div>
                        <b-button variant="success" size="lg" class="font-weight-bold" :disabled="disabledButton"
                                  @click="sendResponse" v-show="question">Enviar
                            respuesta
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import {http} from "../../misc/http";
    import Swal from "sweetalert2";
    import {RingLoader} from 'vue-spinners-css';

    export default {
        name: "Participate",
        components: {
            RingLoader,
        },
        data() {
            return {
                question: null,
                selected: -1,
                timer: 20,
                setInterval: null,
                disabledButton: false,
                loading: true,
            }
        },
        computed: {
            title() {
                return this.question ? this.question.question : '';
            }
        },
        mounted() {
            if (isNaN(parseInt(this.$route.params.anime_id))) {
                this.$router.push('/trivia');
            }

            this.resetForm();
        },
        beforeDestroy() {
            clearInterval(this.setInterval);
        },
        methods: {
            resetForm() {
                this.question = null;
                this.selected = -1;
                this.timer = 20;
                this.setInterval = null;
                this.disabledButton = false;
                this.loading = true;

                this.getQuestion();
            },
            async getQuestion() {
                try {
                    const response = await http.get(`/trivia/participate?difficulty=${this.$route.query.mode}&anime_id=${this.$route.params.anime_id}&withImages=true`);
                    if (response.data.status) {
                        this.question = response.data.question;
                        this.startTimer();
                    }
                } catch (error) {
                    //console.log(error);
                }

                this.loading = false;
            },
            async sendResponse() {
                clearInterval(this.setInterval);
                this.disabledButton = true;

                let is_correct = -1;
                let settings = {
                    title: 'Respuesta incorrecta &#x1F61F;',
                };

                if (this.selected !== -1) {
                    is_correct = this.question.answers.filter(answer => answer.id === this.selected)[0].is_correct;
                }

                try {
                    await http.post('/trivia/participate/web', {
                        question_id: this.question.id,
                        is_correct
                    });

                    if (this.timer === 0) {
                        settings.title = 'Tiempo agotado &#x1F630;';
                    } else if (is_correct) {
                        settings.title = 'Respuesta correcta &#x1F3C6;';
                    }

                    const swalResponse = await Swal.fire({
                        ...settings,
                        confirmButtonColor: '#673bb7',
                        cancelButtonColor: '#d33',
                        showCancelButton: true,
                        confirmButtonText: 'Siguiente pregunta',
                        cancelButtonText: 'Salir del juego',
                    });

                    if (swalResponse.hasOwnProperty('value') && swalResponse.value) {
                        this.resetForm();
                    } else if (swalResponse.hasOwnProperty('dismiss')) {
                        this.$router.push({name: 'trivia'});
                    }
                } catch (error) {
                    //console.log(error);
                }
            },
            startTimer() {
                this.setInterval = setInterval(
                    () => {
                        this.timer--;
                        if (this.timer === 0) {
                            this.sendResponse(null);
                        }
                    }, 1000
                );
            }
        },
    }
</script>

<style scoped>
    #timer-card > .card-body {
        padding: 0.25rem;
    }
</style>